import { render, staticRenderFns } from "./TaxpaymentInfo.vue?vue&type=template&id=34d489fc"
import script from "./TaxpaymentInfo.vue?vue&type=script&lang=js"
export * from "./TaxpaymentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports